import React from "react";
import { IoClose } from "react-icons/io5";
import { fire } from "../../assets/images";
import { FaCheck } from "react-icons/fa";

interface StreakDetails {
  streakCount: number;
  weeklyProgress: Record<string, boolean>;
  goalDescription: string;
}

const StreakModal = ({
  onClose,
  streakDetails,
}: {
  onClose: () => void;
  streakDetails: { data: StreakDetails };
}) => {
  const streak = streakDetails?.data;
  const weeklyProgress = streak?.weeklyProgress || {};
  // console.log(streak);

  // Get the current day of the week
  const currentDay = new Date().toLocaleString("en-US", { weekday: "short" });
  //   console.log(currentDay);

  return (
    <div className="fixed inset-0 font-sora   flex  justify-center items-center pt-16 overflow-auto pb-16  bg-black bg-opacity-75">
      <div className="bg-white dark:bg-[#1C2227] rounded-xl  w-11/12 max-w-md relative">
        <div className="w-full bg-streakBg flex flex-col justify-end bg-cover bg-center h-[250px]">
          <button
            onClick={onClose}
            className="absolute top-4 right-4 text-gray-500"
          >
            <IoClose className="text-xl" />
          </button>
          <div className="flex justify-center mb-4">
            <img src={fire} alt="Flame Icon" className="w-1/2 h-[184px]" />
          </div>
        </div>
        <div className="p-6 w-full mt-4">
          <h4 className="text-[20px] font-semibold text-[#13181B] dark:text-gray-100 text-center mb-2">
            {streak?.streakCount} Days Streak!
          </h4>
          <p className="text-[14px] text-[#13181B] dark:text-gray-100 font-light text-center mb-4">
            of your daily trading goal
          </p>
          <div className="flex justify-center mt-6">
            <div className="flex space-x-2">
              {Object.entries(weeklyProgress).map(([day, active]) => (
                <div key={day} className="flex flex-col items-center gap-1">
                  <h4
                    className={`text-[11px] ${
                      active && currentDay.includes(day)
                        ? "text-[#D70452]"
                        : "text-[#7F7F7F]"
                    }`}
                  >
                    {day}
                  </h4>
                  <div
                    className={`w-[24px] h-[24px] rounded-full  ${
                      active && currentDay.includes(day)
                        ? "bg-transparent"
                        : active
                        ? "bg-[#095B97]"
                        : "border border-[#D5D5D5]"
                    } flex justify-center items-center`}
                  >
                    {active ? (
                      currentDay.includes(day) ? (
                        <img
                          src={fire}
                          alt="Flame Icon"
                          className="w-full h-full object-contain"
                        />
                      ) : (
                        <FaCheck className="text-white text-[12px]" />
                      )
                    ) : null}
                  </div>
                </div>
              ))}
            </div>
          </div>
          <p className="text-center font-manrope font-light text-[#727272] dark:text-gray-200 text-[12px] mt-6">
            {streak?.goalDescription}
          </p>
          <button
            onClick={() => {
              onClose();
            }}
            className="w-full mt-8 font-manrope bg-secondary_button text-white py-4  rounded-xl  font-medium"
          >
            Keep Trading
          </button>
        </div>
      </div>
    </div>
  );
};

export default StreakModal;
